import BotaoFaleConosco from "@/components/BotaoFaleConosco";
import BotaoSimular from "@/components/BotaoSimular";
import RodapeLP from "@/components/rodape-lp";
import { registerMetadata } from "@/services/metadataEvent";
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import DuvidasFrequentes from "../../commom/duvidas-frequentes";
import ComentariosClientes from "../../commom/opiniao-clientes/cometarios";
import "./parcelamento-pix.scss";
import SliderPassoPassoSimulacao from "./SliderPassoPassoSimulacao";



export default function ParcelamentoPix() {
  const [searchParams] = useSearchParams();
  searchParams.get("__firebase_request_key");

  useEffect(() => {
    const metaData = {};
    metaData.utmSource = searchParams.get("utm_source");
    metaData.utmMedium = searchParams.get("utm_medium");
    metaData.utmCampaign = searchParams.get("utm_campaign");
    metaData.utmId = searchParams.get("utm_id");
    metaData.utmTerm = searchParams.get("utm_term");
    const metadataRegister = {
      ...metaData,
      isMobile: isMobile,
      userAction: "VIEW_LANDING_PAGE_PARCELAMENTO_PIX",
      url: window.location.href,
    };
    registerMetadata(metadataRegister, "METADATA_VIEW_SITE_QUITABOLETOS");
  }, [searchParams]);

  return (
    <>
      <Container
        id="parcelamento-pix"
        component="main"
        className="secao-landing-page-parcelamento-pix secao-1-lp-pix">
        <Helmet>
          <title>Quita Boletos - Parcelamento Pix</title>
          <link rel="canonical" href="https://quitaboletos.com.br" />
          <meta
            name="description"
            content="Simule o parcelamento do seu PIX em até 12x no cartão de crédito."
          />
        </Helmet>

        <Grid container sx={{ p: 3 }} maxWidth="lg" className="container-secao-1">
          <Grid size={{ xs: 12, md: 7 }}>
            <Typography variant="h1" sx={{ fontSize: { xs: "2rem", sm: "4rem" }, }}>
              <span className="texto-sem-saldo">Sem saldo</span> <br /> para fazer Pix?
            </Typography>
            <Typography
              variant="h1"
              className="texto-parcele-agora"
              sx={{ fontSize: { xs: "2rem", sm: "4rem" } }}>
              Parcele agora!
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 7 }}>
            <Typography className="texto-secundario">
              A gente antecipa o valor e você quita do seu jeito, sem estresse.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 7 }} className="botao-container">
            <BotaoSimular className="botao-parcelar">
              SIMULAR PARCELAMENTO AGORA
            </BotaoSimular>
          </Grid>
        </Grid>
      </Container>

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-2-lp-pix">
        <Grid container className="container" maxWidth="xl">
          <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, }}>
            <Typography className="titulo">
              Porque escolher a Quita?
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }} sx={{ my: "1rem", px: { xs: 2, md: 0 } }}>
            <ul className="lista-vantagens">
              <li><strong>Parcele seu pix</strong> em poucos cliques — mesmo com o nome negativado.</li>
              <li>Sem burocracia, <strong>100% online</strong> e com <strong>segurança</strong> garantida.</li>
              <li><strong>Escolha</strong> a parcela que cabe no seu bolso.</li>
              <li>Passo a passo <strong>transparente</strong> e <strong>descomplicado</strong>.</li>
              <li>Aguarde a aprovação de segurança para receber o <strong>comprovante</strong>.</li>
              <li>Verifique se o valor total solicitado está <strong>disponível</strong> no seu limite de crédito.</li>
              <li><strong>Ficou com dúvidas?</strong> Fale com o nosso suporte pelo WhatsApp!</li>
            </ul>
          </Grid>
        </Grid>
      </Container >

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-3-lp-pix">
        <Grid container maxWidth="xl">
          <Grid className="container" size={{ xs: 12, md: 6 }} sx={{ margin: { xs: 0, md: "auto" } }}>
            <Typography className="titulo">
              Utilize o seu cartão de crédito para <span>parcelar</span> <span>Pix</span> em até 12x.
            </Typography>

            <Typography className="descricao">
              A gente paga seu <strong>Pix à vista</strong> e você quita do seu jeito, sem estresse.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-4-lp-pix">
        <Grid container maxWidth="xl">
          <Grid size={12}>
            <Typography className="titulo">
              Como funciona
            </Typography>
          </Grid>

          <Grid size={12}>
            <SliderPassoPassoSimulacao />
          </Grid>
        </Grid>
      </Container>

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-5-lp-pix">
        <Grid container maxWidth="xl" spacing={4}>
          <Grid size={{ xs: 12, sm: 6 }} className="container-card end">
            <Card className="card">
              <CardMedia
                sx={{ height: 210, width: 272 }}
                image="/landing-pages/parcelamento-pix/homem-segurando-bandeira.png"
                title="homem segurando bandeira do brasil"
              />
              <CardContent className="card-content">
                <strong>+20 estados</strong> brasileiros <strong>atendidos</strong>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }} className="container-card start">
            <Card className="card">
              <CardMedia
                sx={{ height: 210, width: 272 }}
                image="/landing-pages/parcelamento-pix/avalicao.png"
                title="Cliente avaliando solucao"
              />
              <CardContent className="card-content">
                <strong>8 a cada 10 clientes</strong> avaliam nossa solução e atendimento com <strong>nota 10!</strong>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }} className="container-card end">
            <Card className="card">
              <CardMedia
                sx={{ height: 210, width: 272 }}
                image="/landing-pages/parcelamento-pix/transacao-online.png"
                title="Transacao online"
              />
              <CardContent className="card-content">
                <strong>100% online</strong>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }} className="container-card start">
            <Card className="card">
              <CardMedia
                sx={{ height: 210, width: 272 }}
                image="/landing-pages/parcelamento-pix/seguranca.png"
                title="Seguranca em cada etapa"
              />
              <CardContent className="card-content">
                <strong>Segurança em cada etapa</strong> do parcelamento
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container >

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-6-lp-pix">
        <Grid container sx={{ p: { xs: 0, md: 3 }, m: { xs: 0, md: "auto" } }} maxWidth="xl">
          <Grid size={{ xs: 12, md: 6 }}>
            <Grid container sx={{ display: "flex", justifyContent: "center" }}>
              <Grid size={12} align="center">
                <Typography className="titulo">
                  Parcelar seu Pix é muuuito fácil!
                </Typography>
              </Grid>

              <Grid size={12} sx={{ width: { xs: "100%", md: "55%" }, }}>
                <Typography className="descricao">
                  <b>Sabe aquela dívida que é uma dor de cabeça?</b> <br />
                  Nossa solução é uma mão na roda para manter o seu nome limpo:{" "}
                  <span className="destaque">parcele como e em quantas vezes preferir.</span>
                </Typography>
              </Grid>

              <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
                <BotaoSimular className="botao-simular-pix-parcelado">
                  SIMULAR PIX PARCELADO
                </BotaoSimular>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }} className="imagem-container">
            {isMobile ? (
              <img alt="" src="/landing-pages/parcelamento-pix/banner-secao-6-mobile.png" />
            ) : (
              <img alt="" src="/landing-pages/parcelamento-pix/banner-secao-6.png" />
            )}
          </Grid>
        </Grid>
      </Container>

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-7-lp-pix">
        <Grid container spacing={2} sx={{ display: { xs: "flex", sm: "flex" }, flexDirection: "column", alignItems: "center" }} maxWidth="xl">
          <Grid size={12} className="card-vantagens">
            <Grid size={12} align="center">
              <Grid size={{ xs: 12, md: 6.7 }} className="container-vantagem">
                <Grid className="item-vantagem">
                  <img src="/landing-pages/parcelamento-pix/check-secao-7.svg" alt="icone check" className="check-icon" />
                </Grid>

                <Grid>
                  <Typography className="descricao-vantagem">
                    <b>Sem consulta ao cpf,</b> sem estresse, sem enrolação.
                  </Typography>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 6.7 }} className="container-vantagem">
                <Grid className="item-vantagem">
                  <img src="/landing-pages/parcelamento-pix/check-secao-7.svg" alt="icone check" className="check-icon" />
                </Grid>
                <Grid>
                  <Typography className="descricao-vantagem">
                    Na Quita, <b>você paga depois.</b>
                  </Typography>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 6.7 }} className="container-vantagem">
                <Grid className="item-vantagem">
                  <img src="/landing-pages/parcelamento-pix/check-secao-7.svg" alt="icone check" className="check-icon" />
                </Grid>
                <Grid>
                  <Typography className="descricao-vantagem">
                    <b>Evite juros e multas</b> — pague hoje, sem <br /> comprometer o orçamento de uma vez só.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={12} align="center">
            <Grid size={{ xs: 12, sm: 7, md: 8 }}>
              <Typography className="titulo-suporte">
                Tire suas dúvidas com o nosso suporte:
              </Typography>


              <BotaoFaleConosco className="botao-fale-conosco">
                FALE COM A GENTE AGORA!
              </BotaoFaleConosco>
            </Grid>
          </Grid>
        </Grid>
      </Container>

      <Container component="section" className="secao-landing-page-parcelamento-pix secao-8-lp-pix">
        <Grid container maxWidth="xl">

          <Grid size={12}>
            <Grid container className="cards-comentarios">
              <ComentariosClientes
                breakpoint={{
                  0: {
                    slidesPerView: 1,
                  },
                  1000: {
                    slidesPerView: 2,
                  },
                }}
                pagination={{
                  clickable: isMobile ? true : false,
                  dynamicBullets: true,
                  bulletClass: "swiper-pagination-bullet",

                }}
              />
            </Grid>
          </Grid>

          <Grid size={12} align="center" sx={{ padding: "1rem" }}>
            <Typography className="titulo">
              Dúvidas frequentes
            </Typography>

            <Grid container maxWidth="md" >
              <DuvidasFrequentes />
            </Grid>
          </Grid>

          <Grid size={12} align="center">
            <BotaoSimular className="botao-simular">
              QUERO SIMULAR AGORA
            </BotaoSimular>
          </Grid>
        </Grid>
      </Container>

      <RodapeLP />
    </>
  );
}
